import { FuelTableContainer } from 'pages/FuelManagement/FuelManagement.styled'
import styled from 'styled-components'

export const AccommodationRoomsTableContainer = styled(FuelTableContainer)`
  width: 100%;
`
